import { render, staticRenderFns } from "./RegisterCompany.vue?vue&type=template&id=61f33a6f"
import script from "./RegisterCompany.vue?vue&type=script&lang=ts"
export * from "./RegisterCompany.vue?vue&type=script&lang=ts"
import style0 from "./RegisterCompany.vue?vue&type=style&index=0&id=61f33a6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports